import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-update-label",
  "use": "icon-update-label-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-update-label\">\n<rect y=\"1\" width=\"20\" height=\"16\" rx=\"4\" fill=\"#32C281\" />\n<path d=\"M8.256 4.66V9.976C8.256 10.608 8.42 11.084 8.748 11.404C9.084 11.724 9.548 11.884 10.14 11.884C10.74 11.884 11.204 11.724 11.532 11.404C11.868 11.084 12.036 10.608 12.036 9.976V4.66H13.404V9.952C13.404 10.632 13.256 11.208 12.96 11.68C12.664 12.152 12.268 12.504 11.772 12.736C11.276 12.968 10.728 13.084 10.128 13.084C9.528 13.084 8.98 12.968 8.484 12.736C7.996 12.504 7.608 12.152 7.32 11.68C7.032 11.208 6.888 10.632 6.888 9.952V4.66H8.256Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/update-label.svg
// module id = 4i5/
// module chunks = 258